import React from 'react';
import {
  Button,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import translations from '../../languages/i18n';

import fieldStyles from '../../styles/fieldStyles';

// **********************************************************
// Valors per a type: accept, cancel

export default function BasicButton({ handleClick, type, text }) {
  const classes = fieldStyles();

  return (
    <Button
      className={classes[type + 'Button']}
      variant='contained'
      size='large'
      onClick={handleClick}
    >
      {/* Si el botó no té el props text, posam el valor per defecte segons correspongui al seu tipus */}
      {text || translations['_' + type]}
    </Button>
  );
}

// Indica i controla els props que se han de passar al component
BasicButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  text: PropTypes.string,
  type: PropTypes.string.isRequired,
};
